import Header from '../../../shared/Header';
import {Box, Flex, Stack} from '../../../shared/layouts';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import Card from '../../../shared/Card';
import Button from '../../../shared/Button';
import { useTranslation } from 'react-i18next';
import DownloadIcon from 'imagesUwKluis/svg/download_big.svg';
import DataSourcesList from './DataSourcesList';
import CheckmarkIcon from 'imagesUwKluis/svg/checkmark.svg';
import styled from '@emotion/styled';

const SuccessIcon = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  zIndex: 3,
  display: 'flex',
  alignItems: 'center',
  background: theme.colors.succes,
  width: '36px',
  height: '36px',
  padding: theme.space.s,
  borderRadius: '50%',
  boxShadow: `2px`,
  transform: 'translate(-50%, -50%)',
  '> svg': {
    fill: theme.colors.white,
  },
}));

export const RetrievingDataSection = ({
  sourceType,
  isFetching,
  isLoading,
  refetch,
  url,
  qr,
  available_data_sources,
}) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );

  return (
    <Card>
      <Stack space={'m'}>
        <Header
          icon={<DownloadIcon />}
          button={isMinDesktop && sourceType.logo}
          title={t('Haal je gegevens op')}
          variant="section"
          width={'100%'}
        />
        <p>
          <strong>
            {t('Volg de instructies in de {{app_name}} app', {
              app_name: sourceType.app_name,
            })}
          </strong>
          <br />
          {t(
            'Verzamel de gevraagde gegevens en verzend deze als je klaar bent.'
          )}
        </p>
          <Flex
            minWidth={'100%'}
            flexDirection={{ mobile: 'column', desktop: 'row' }}
            justifyContent={'space-between'}
            borderTop={'default'}
            pt={'m'}
            css={{
              gap: isMinDesktop ? '32px' : null,
              '> *': { flex: '1 0 40%' }
          }}
          >
            <Stack space={'m'}>
              <strong>
                {t('Bij deze overheidsdiensten worden gegevens opgehaald:')}
              </strong>
              <DataSourcesList sources={available_data_sources} />
            </Stack>
            <Stack
              marginTop={{ mobile: 'm', desktop: 'l' }}
              alignItems={'center'}
              space={'m'}
            >
              {isMinDesktop && (
                <>
                  {qr && (
                    <Box position={'relative'}>
                      <SuccessIcon>
                        <CheckmarkIcon />
                      </SuccessIcon>
                      <img
                        src={'data:image/png;base64,' + qr}
                        alt={t('{{app_name}} qr code', {
                          app_name: sourceType.app_name,
                        })}
                        width={'216'}
                        height={'216'}
                        style={{
                          opacity: '0.1',
                          filter: 'blur(2px)',
                        }}
                      />
                    </Box>
                  )}
                  <Button
                    onClick={() => refetch()}
                    buttonSize={'small'}
                    disabled={isFetching}
                  >
                    {t('Nieuwe QR code')}
                  </Button>
                </>
              )}
              {!isMinDesktop && !isLoading && (
                <>
                  <Button
                    width={!isMinDesktop ? '100%' : null}
                    disabled={isFetching}
                    onClick={() => window.open(url)}
                  >
                    {t('Open de {{app_name}} app', {
                      app_name: sourceType.app_name,
                    })}
                  </Button>
                  <Button
                    variant={'secondary-outline'}
                    width={!isMinDesktop ? '100%' : null}
                    onClick={() => refetch()}
                    buttonSize={'small'}
                    disabled={isFetching}
                  >
                    {t('Nieuwe link')}
                  </Button>
                </>
              )}
            </Stack>
          </Flex>
        </Stack>
    </Card>
  );
};

export default RetrievingDataSection;
